//
//
//
//
//
//
//
//
//

export default {
    props: {
        fn: Function,
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        async onClick() {
            this.loading = true;

            await this.fn();

            this.loading = false;
        },
    },
};
